import React, { useEffect, useState } from "react";
import {
  buildResultadosFaseEndpoint,
  extractFaseFromReport,
  getPhaseTypeProps,
} from "../categorias.utils";
import FaseMejorDe3    from "./FaseMejorDe3";
import FaseEliminacion from "./FaseEliminacion";
import FaseGrupo       from "./FaseGrupo";

const FaseDetalle = ({ eventCategoryId, phaseId, vista = "llaves", idsport }) => {
  const [fase, setFase]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState("");

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError("");
    setFase(null);

    const load = async () => {
      try {
        const res = await fetch(buildResultadosFaseEndpoint(eventCategoryId, phaseId));
        if (!res.ok) throw new Error(`Error ${res.status}`);
        const data = await res.json();
        if (!isMounted) return;
        setFase(extractFaseFromReport(data));
      } catch (err) {
        if (!isMounted) return;
        setError(err.message || "Error cargando resultados");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    load();
    return () => { isMounted = false; };
  }, [eventCategoryId, phaseId]);

  // ── Estado: cargando ────────────────────────────────────────────────────────
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[180px] py-10 gap-3">
        <div className="p-4 rounded-full bg-black/[0.04]">
          <div className="w-8 h-8 border-[3px] border-blue-600 border-t-transparent rounded-full animate-spin" />
        </div>
        <span className="text-[0.7rem] font-semibold uppercase tracking-widest text-gray-400">
          Cargando resultados
        </span>
      </div>
    );
  }

  // ── Estado: error ───────────────────────────────────────────────────────────
  if (error) {
    return (
      <div className="m-4 flex items-start gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-700">
        <span className="mt-0.5">⚠️</span>
        <span>{error}</span>
      </div>
    );
  }

  // ── Estado: sin datos ───────────────────────────────────────────────────────
  if (!fase) {
    return (
      <div className="m-4 flex items-start gap-2 px-4 py-3 bg-blue-50 border border-blue-200 rounded-xl text-sm text-blue-700">
        <span className="mt-0.5">ℹ️</span>
        <span>Sin datos para esta fase.</span>
      </div>
    );
  }

  const phaseType   = String(fase.phaseType || "").toLowerCase();
  const isWrestling = Number(idsport) === 25;
  const VISTAS = {
    mejor_de_3:  <FaseMejorDe3    fase={fase} vista={vista} />,
    eliminacion: <FaseEliminacion fase={fase} vista={vista} showWrestlingRanking={isWrestling} />,
    grupo:       <FaseGrupo       fase={fase} vista={vista} />,
  };

  // ── Estado: tipo de fase no implementado ────────────────────────────────────
  return (
    VISTAS[phaseType] ?? (
      <div className="m-4 flex items-start gap-2 px-4 py-3 bg-blue-50 border border-blue-200 rounded-xl text-sm text-blue-700">
        <span className="mt-0.5">ℹ️</span>
        <span>
          Vista para tipo{" "}
          <strong className="font-bold">{getPhaseTypeProps(fase.phaseType).label}</strong>{" "}
          en desarrollo.
        </span>
      </div>
    )
  );
};

export default FaseDetalle;